const LegalizationDocuments = () => {
    return (
        <div>
        <div className="flex flex-col justify-center items-center">
        <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">

                <div className="px-1 flex flex-col justify-center lg:max-w-[25rem] md:w-[30rem]">
                    <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                        Legalisation Documents
                    </h1>
                    <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                        Visatronix delivers over 100,000 passports at applicants’ doorsteps. 1,000+ Express Centres reaching 
                        out to more than 2,500 locations make it safely possible with diligence. Each processed application, 
                        whether successful or not, involves a number of documents to be notarised and/or attested. 
                        Each such legalisation or attestation is taken care of by Visatronix centrally.
                    </p>
                   
                </div>
                <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
                    <img src="/visatronix/legalistiondocuments.jpg" alt="" className="rounded-md max-w-[100%]"/>
                    
                </div>
            </div>

        </div>

    </div>
    )
};
export default LegalizationDocuments;